import React, { useState, useEffect } from "react";
import styled from 'styled-components';
import Dropdown from 'react-bootstrap/Dropdown';
import Form from 'react-bootstrap/Form';
import {extractHeader, isDateAfter} from '../../utils/utilsHelpers';
import Select, {components} from "react-select";
import {SECONDARY_COLOR} from '../../constants/stylingConstants.js';
import CustomOptionWithGtm from "../../utils/CustomOptionWithGtm";

const CustomToggle = React.forwardRef(({ children, onClick, style, className }, ref) => {
    return (
    <a
        ref={ref}
        className={"dropdown-toggle"}
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
      {children}
    </a>
)});

const CustomMenu = React.forwardRef(
    ({ children, style, className, 'aria-labelledby': labeledBy }, ref) => {
        return (
            <div
                ref={ref}
                style={{maxHeight: maxListHeight}}
                className={`filters-dropdown-menu ${className} custom-scroller`}
                aria-labelledby={labeledBy}
            >
            {React.Children.toArray(children)}
            </div>
        );
      },
)

const CustomItem = React.forwardRef(({children, className, onClick, id}, ref) => {
    return (
        <a
            ref={ref}
            className={'dropdown-item'}
            onClick={(e) => onClick(e)}
            id={id}
        >
            {children}
        </a>
    )
});

const maxListHeight = '300px';

export default function DropdownFilter(props) {

    const [isOpen, setIsOpen] = useState(props.defaultOpen);

    useEffect(() => {

    });

    const onToggleHandler = (isOpen, e) => {
        if  (e.source != 'select') {
            setIsOpen(isOpen);
        }
        if (props.onToggleHandler) {
          props.onToggleHandler(isOpen, props.filterName, e.source)
        }
    }

    if(props.dropdownCheckBoxes) {
        return (
            <>
                <Dropdown
                    show={isOpen}
                    className={'dropdown-filter'}
                    key={props.index}
                    onSelect={(key, e) => props.onItemSelect(e, props.filterName, 'dropdown')}
                    onToggle={(isOpen, e) => onToggleHandler(isOpen, e)}
                >
                    <Dropdown.Toggle as={CustomToggle} variant="success" id="dropdown-basic" style={{width: '100%'}}>
                        <span>{extractHeader(props.filterName)}</span>
                        <StyledIcon className={"fas fa-chevron-right"} style={{transform: isOpen ? 'rotate(90deg)' : 'rotate(0deg)'}}></StyledIcon>
                    </Dropdown.Toggle>

                    <Dropdown.Menu as={CustomMenu}>
                        {
                            props.filters[props.filterName].map((item, index) => {
                                return (
                                    <Dropdown.Item as={CustomItem} key={index} id={item.label}>
                                        <div className={'d-flex'}>
                                            <Form.Check
                                                style={{pointerEvents: 'none'}}
                                                className={'my-0 align-self-center form-check-primary'}
                                                checked={props.isCheckedHandler(props.filterName, item.label, 'dropdown')}
                                                onChange={() => {}}
                                                type="checkbox"
                                                label=""
                                            />
                                            <StyledFilterItem>
                                                {item.renderObject || item.label}
                                            </StyledFilterItem>
                                            <div className={'ms-auto'}>
                                                {item.sum}
                                            </div>
                                        </div>
                                    </Dropdown.Item>
                                )
                            })
                        }
                    </Dropdown.Menu>
                </Dropdown>
            </>
        )
    } else {
        let selectedValue = props.filters[props.filterName].find((item) => props.isCheckedHandler(props.filterName, item.label, 'dropdown'));
        const handleMenuOpen = () => { setIsOpen(!selectedValue)}
        const gtmProps = props.gtmEventRegion ? {
          gtmEventRegion: props.gtmEventRegion,
          gtmEventElement: `filter-${props.filterName.replace("_", "-")}`} : {}

        return (
            <Select
                isClearable={true}
                isSearchable={false}
                defaultValue={selectedValue}
                menuShouldScrollIntoView={false}
                noOptionsMessage={() => null}
                onMenuOpen={() => handleMenuOpen()}
                menuIsOpen={isOpen}
                onBlur={() => setIsOpen(false)}
                blurInputOnSelect={true}
                // components={{DropdownIndicator: DropdownIndicator}}
                options={props.filters[props.filterName]}
                components={{Option: (optionProps) => <CustomOptionWithGtm {...optionProps} {...gtmProps} />}}
                onChange={(selectedOption, actionMeta) => {
                    setIsOpen(false);
                    props.onItemSelect({}, props.filterName, 'dropdown', actionMeta.action === 'clear' ? actionMeta.removedValues[0]?.value : selectedOption?.value)}}
                styles={{
                    control: (styles) => ({
                        ...styles,
                        cursor: 'pointer'
                    }),
                    indicatorSeparator: () => ({ display: 'none' }),
                    singleValue: (styles) => ({
                        ...styles,
                        color: SECONDARY_COLOR
                    })
                }}
            />
        )
    }

}

const StyledIcon = styled.i`
    font-size: 12px;
    align-self: center;
    transition: transform .15s;
`;

const StyledFilterItem = styled.span`
    width: -webkit-fill-available;
    padding-right: 10px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;